export const SKAUPAT_HREF_PRODUCTION = 'https://www.s-kaupat.fi'
